module.exports = __webpack_public_path__ + "img/22.7d691cc5.png";